export enum AppColors {
	White = '#FFFFFF',
	Black = '#000000',
	Green = '#0B5E22',
	Yellow = '#FF9B0C',
	DarkBlue = '#20233E',
	LightGrey = '#EFEFF2',
	DarkGrey = '#9092A6',
	Midnight = '#0A0C1F',
}
